<shared-ui-page [pageTitle]="pageTitle">
    <div class="wrapper">
        <div class="bg-white shadow-level-2 mb-24">
            <div class="p-12 border-b border-neutral-extra-light">
                <div class="flex justify-between items-center">
                    <div>
                        <div
                            *ngIf="!(isLoading | async)"
                            class="text-header-5 font-header-5"
                        >
                            {{ billingPlanService.billingPlanVM?.Name }}
                        </div>
                        <div
                            *ngIf="isLoading | async"
                            class="shimmer dark-shimmer w-200 h-16"
                        ></div>
                        <div
                            class="
                                text-label-2
                                font-label-2
                                text-secondary-main
                            "
                        >
                            Ваш план на Внешний и Внутренний документооборот
                        </div>
                    </div>
                    <shared-ui-icon-status-text
                        *ngIf="!(isLoading | async)"
                        [text]="billingPlanService.billingPlanVM?.StatusText"
                        [color]="billingPlanService.billingPlanVM?.StatusColor"
                    >
                    </shared-ui-icon-status-text>
                    <div
                        *ngIf="isLoading | async"
                        class="shimmer dark-shimmer w-100 h-16"
                    ></div>
                </div>

                <div class="flex justify-between items-center mb-12">
                    <div class="text-paragraph-2 font-paragraph-2">
                        Стоимость в месяц
                    </div>
                    <div
                        *ngIf="!(isLoading | async)"
                        class="text-sub-header-2 font-sub-header-2 font-bold"
                    >
                        {{
                            billingPlanService.billingPlanVM?.Price ?? 0
                                | mask: 'separator.2'
                        }}
                        тг
                    </div>
                    <div
                        *ngIf="isLoading | async"
                        class="shimmer dark-shimmer w-100 h-16"
                    ></div>
                </div>
            </div>

            <div
                class="p-12 border-b border-neutral-extra-light"
                *ngIf="billingPlanService.billingPlanVM?.ExternalPackages"
            >
                <div
                    *ngFor="
                        let externalPackage of billingPlanService.billingPlanVM
                            ?.ExternalPackages
                    "
                >
                    <div class="text-paragraph-2 mb-6 font-bold">
                        Внешний документооборот
                        <span
                            *ngIf="
                                billingPlanService.billingPlanVM
                                    ?.ExternalPackages?.length ??
                                0 > 1
                            "
                            >{{ externalPackage.Name }}</span
                        >
                    </div>

                    <div
                        *ngIf="
                            billingPlanService.billingPlanVM?.ExternalPackages
                                ?.length ??
                            0 > 1
                        "
                        class="
                            text-label-2
                            font-label-2
                            mb-6
                            text-secondary-main
                        "
                    >
                        Период действия плана с
                        {{ externalPackage.StartDate | date: 'dd.MM.yyyy' }} по
                        {{ getEndDateStr(externalPackage.EndDate) }}
                    </div>

                    <div class="flex justify-between items-center">
                        <div class="text-paragraph-2 font-paragraph-2">
                            Стоимость за документ
                        </div>
                        <div
                            class="
                                text-sub-header-2
                                font-sub-header-2 font-bold
                            "
                        >
                            {{
                                externalPackage.DocumentBasePrice ?? 0
                                    | mask: 'separator.2'
                            }}
                            тг
                        </div>
                    </div>

                    <div class="flex justify-between items-center">
                        <div class="text-paragraph-2 font-paragraph-2">
                            Количество документов в текущем месяце
                        </div>
                        <div
                            class="
                                text-sub-header-2
                                font-sub-header-2 font-bold
                            "
                        >
                            {{ externalPackage.DocumentsCount }}
                        </div>
                    </div>

                    <div class="flex justify-between items-center">
                        <div class="text-paragraph-2 font-paragraph-2">
                            Сумма к оплате за пакет
                        </div>
                        <div
                            class="
                                text-sub-header-2
                                font-sub-header-2 font-bold
                            "
                        >
                            {{
                                externalPackage.TotalPrice ?? 0
                                    | mask: 'separator.2'
                            }}
                            тг
                        </div>
                    </div>

                    <div class="flex justify-between items-center mb-12">
                        <div class="text-paragraph-2 font-paragraph-2">
                            Статус
                        </div>
                        <shared-ui-icon-status-text
                            [text]="externalPackage.StatusText"
                            [color]="externalPackage.StatusColor"
                        >
                        </shared-ui-icon-status-text>
                    </div>
                </div>
            </div>

            <div
                class="p-12 border-b border-neutral-extra-light"
                *ngIf="isInternalPackage()"
            >
                <div class="text-paragraph-2 font-bold mb-6">
                    Внутренний документооборот
                </div>

                <div class="flex justify-between items-center">
                    <div class="text-paragraph-2 font-paragraph-2">
                        Объем хранилища
                    </div>
                    <div class="text-sub-header-2 font-sub-header-2 font-bold">
                        {{
                            billingPlanService.billingPlanVM?.InternalPackage
                                ?.MemoryCapacity
                        }}
                        Gb
                    </div>
                </div>

                <div class="flex justify-between items-center">
                    <div class="text-paragraph-2 font-paragraph-2">
                        Использовано хранилища
                    </div>
                    <div class="text-sub-header-2 font-sub-header-2 font-bold">
                        <span
                            class="
                                text-paragraph-2
                                font-paragraph-2
                                text-secondary-main
                            "
                            >{{
                                billingPlanService.billingPlanVM
                                    ?.InternalPackage?.UsedCapacityPercent
                            }}% </span
                        >{{
                            billingPlanService.billingPlanVM?.InternalPackage
                                ?.UsedCapacity
                        }}
                        Gb
                    </div>
                </div>

                <div class="flex justify-between items-center">
                    <div class="text-paragraph-2 font-paragraph-2">
                        Сумма к оплате за пакет
                    </div>
                    <div class="text-sub-header-2 font-sub-header-2 font-bold">
                        {{
                            billingPlanService.billingPlanVM?.InternalPackage
                                ?.Price ?? 0 | mask: 'separator.2'
                        }}
                        тг
                    </div>
                </div>

                <div class="flex justify-between items-center mb-12">
                    <div class="text-paragraph-2 font-paragraph-2">Статус</div>
                    <shared-ui-icon-status-text
                        [text]="
                            billingPlanService.billingPlanVM?.InternalPackage
                                ?.StatusText
                        "
                        [color]="
                            billingPlanService.billingPlanVM?.InternalPackage
                                ?.StatusColor
                        "
                    >
                    </shared-ui-icon-status-text>
                </div>
            </div>

            <div class="p-12">
                <div class="flex justify-between items-center">
                    <div>
                        <div class="text-paragraph-2 font-paragraph-2">
                            Сумма к оплате за текущий месяц
                        </div>
                        <div
                            *ngIf="!(isLoading | async)"
                            class="
                                text-label-2
                                font-label-2
                                text-secondary-main
                            "
                        >
                            {{ nextMonth | date: 'dd.MM.yyyy' }} (через
                            {{ daysBeforePaymentLeft() }} д.)
                        </div>
                        <div
                            *ngIf="isLoading | async"
                            class="shimmer dark-shimmer w-120 h-12"
                        ></div>
                    </div>

                    <div
                        *ngIf="!(isLoading | async)"
                        class="text-sub-header-2 font-sub-header-2 font-bold"
                    >
                        {{
                            billingPlanService.billingPlanVM
                                ?.CurrentMonthPrice ?? 0 | mask: 'separator.2'
                        }}
                        тг
                    </div>
                    <div
                        *ngIf="isLoading | async"
                        class="shimmer dark-shimmer w-100 h-16"
                    ></div>
                </div>

                <div class="flex justify-between items-center mb-24">
                    <div class="text-paragraph-2 font-paragraph-2">
                        Задолженность за предыдущий месяц
                    </div>
                    <div
                        *ngIf="!(isLoading | async)"
                        class="text-sub-header-2 font-sub-header-2 font-bold"
                    >
                        {{
                            billingPlanService.billingPlanVM?.LastMonthDebt ?? 0
                                | mask: 'separator.2'
                        }}
                        тг
                    </div>
                    <div
                        *ngIf="isLoading | async"
                        class="shimmer dark-shimmer w-100 h-16"
                    ></div>
                </div>

                <div class="flex justify-end items-center mb-12">
                    <shared-ui-button
                        [appearance]="'outline'"
                        [loading]="isLoading | async"
                        (click)="navigate('./billing/subscriptions')"
                    >
                        Подробнее
                    </shared-ui-button>
                </div>
            </div>
        </div>

        <billing-ui-billing-block
            [config]="cardBlock"
            [loading]="isLoading | async"
            (btnClick)="navigate('./billing/payment')"
        >
            <ng-container content>
                <div>
                    <billing-ui-payment-type-info
                        [loading]="isLoading | async"
                        [config]="paymentService.paymentTypeInfo"
                        [appearance]="'short'"
                    ></billing-ui-payment-type-info>
                </div>
            </ng-container>
        </billing-ui-billing-block>

        <billing-ui-billing-block
            [config]="historyBlock"
            [loading]="isLoading | async"
            (btnClick)="navigate('./billing/payments-history')"
        >
            <ng-container content>
                <div>
                    <billing-ui-payments-history
                        *ngIf="!(isLoading | async) && !loadingHistory"
                        [payments]="paymentsHistoryService.paymentsHistory"
                        [hideButtons]="true"
                        (downloadPayment)="download($event)"
                    >
                    </billing-ui-payments-history>
                    <billing-ui-payments-history
                        *ngIf="(isLoading | async) || loadingHistory"
                        [loading]="true"
                    >
                    </billing-ui-payments-history>
                </div>
            </ng-container>
        </billing-ui-billing-block>
    </div>
</shared-ui-page>
